import {
  AUTH_LOGIN_CODE_URL,
  AUTH_LOGIN_EMAIL_CODE_URL,
  AUTH_LOGIN_EMAIL_URL,
  LoginCodeRequest,
  LoginCodeResponse,
  LoginEmailRequest,
  LoginEmailResponse,
} from "@project/shared-types";
import apiFetchPost from "../../../api/apiClient";

export const LoginExecutorCodeAPI = async (dataResuest: LoginCodeRequest) => {
  try {
    const response = await apiFetchPost<LoginCodeRequest, LoginCodeResponse>(
      AUTH_LOGIN_CODE_URL,
      dataResuest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const LoginClientEmailAPI = async (dataResuest: LoginEmailRequest) => {
  const response = await apiFetchPost<LoginEmailRequest, LoginEmailResponse>(
    AUTH_LOGIN_EMAIL_URL,
    dataResuest
  );
  return response;
};
export const LoginClientEmailCodeAPI = async (
  dataResuest: LoginEmailRequest
) => {
  const response = await apiFetchPost<LoginEmailRequest, LoginCodeResponse>(
    AUTH_LOGIN_EMAIL_CODE_URL,
    dataResuest
  );
  return response;
};
